import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map } from 'immutable';
import moment from 'moment';

import ActionsForm from '../../../ActionsForm/ActionsForm.jsx';

const ACTIONS = {
    'your': [
        {id: 'cancel', name: 'Mark as reviewed'},
        {id: 'unassign', name: 'Unassign'}
    ],
    'none': [
        {id: 'assign', name: 'Assign to me'}
    ],
    'other': [
        {id: 'unassign', name: 'Unassign'}
    ]
};

class KeyAccountChanges extends React.Component {
    static propTypes = {
        type: PropTypes.string,
        status: PropTypes.string,
        className: PropTypes.string,
        onCancelRequest: PropTypes.func.isRequired,
        onAssignRequest: PropTypes.func.isRequired,
        onUnassignRequest: PropTypes.func.isRequired,
        onOpenAccountRequest: PropTypes.func.isRequired
    };

    static defaultProps = {
        className: ''
    };

    constructor(props, context) {
        super(props, context);
    }

    openAccount(id, name) {
        this.props.onOpenAccountRequest(id, name);
    }

    doAction(accountChange) {
        return (field, action) => {
            const { onCancelRequest, onAssignRequest,
                    onUnassignRequest } = this.props;
            if (action === 'unassign') {
                onUnassignRequest(accountChange);
            } else if (action === 'assign') {
                onAssignRequest(accountChange);
            } else if (action === 'cancel') {
                onCancelRequest(accountChange);
            }
        };
    }

    renderRow(accountChange, type) {
        let row = (
            <tr key={accountChange.get('id')} data-test={`key-account-changes-row-${accountChange.get('accountId', Map())}`}>
                <td>{moment(accountChange.get('createdAt')).format('DD-MM-YYYY HH:mm')}</td>
                <td>
                    <div className={'contents'}>
                        <div className={'customerTab'}
                             onClick={(e) => this.openAccount(accountChange.get('accountId', Map()),
                                 accountChange.get('accountName', Map()))}>
                            <span className={'status online'}></span>
                            {accountChange.get('accountName', Map())}
                            <br/>
                            <span className={'customerId'}>{accountChange.get('accountId', Map())}</span>
                            <span className={'tag'}></span>
                        </div>
                    </div>
                </td>
                <td data-test='key-account-changes-email'>
                    <div>{accountChange.getIn([ 'details', 'email', 'value' ])}</div>
                    <div><strong>{accountChange.getIn([ 'details', 'email', 'oldValue' ])}</strong></div>
                </td>
                <td data-test='key-account-changes-firstname'>
                    <div>{accountChange.getIn([ 'details', 'firstName', 'value' ])}</div>
                    <div><strong>{accountChange.getIn([ 'details', 'firstName', 'oldValue' ])}</strong></div>
                </td>
                <td data-test='key-account-changes-surname'>
                    <div>{accountChange.getIn([ 'details', 'surname', 'value' ])}</div>
                    <div><strong>{accountChange.getIn([ 'details', 'surname', 'oldValue' ])}</strong></div>
                </td>
                <td data-test='key-account-changes-address-line-1'>
                    <div>{accountChange.getIn([ 'details', 'addressLine1', 'value' ])}</div>
                    <div><strong>{accountChange.getIn([ 'details', 'addressLine1', 'oldValue' ])}</strong></div>
                </td>
                <td data-test='key-account-changes-address-line-2'>
                    <div>{accountChange.getIn([ 'details', 'addressLine2', 'value' ])}</div>
                    <div><strong>{accountChange.getIn([ 'details', 'addressLine2', 'oldValue' ])}</strong></div>
                </td>
                <td data-test='key-account-changes-postcode'>
                    <div>{accountChange.getIn([ 'details', 'postCode', 'value' ])}</div>
                    <div><strong>{accountChange.getIn([ 'details', 'postCode', 'oldValue' ])}</strong></div>
                </td>
                <td data-test='key-account-changes-country'>
                    <div>{accountChange.getIn([ 'details', 'country', 'value' ])}</div>
                    <div><strong>{accountChange.getIn([ 'details', 'country', 'oldValue' ])}</strong></div>
                </td>
                <td>
                    <ActionsForm
                        onChange={this.doAction.call(this, accountChange)}
                        actions={ACTIONS[type]}
                        dataTest='key-account-changes-action-form'
                    />
                </td>
            </tr>
        );
        return [ row ];
    }

    render() {
        const {data, type} = this.props;
        let table = (
            <table className={ 'review-account' }>
                <thead>
                <tr>
                    <th>Date Detected</th>
                    <th>Customer</th>
                    <th>Email Address</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Address Line 1</th>
                    <th>Address Line 2</th>
                    <th>Postcode</th>
                    <th>Country</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                {data.map(d => this.renderRow(d, type)).toArray()}
                </tbody>
            </table>
        );

        return (
            <div>{table}</div>
        );
    }
}

export default KeyAccountChanges;
